export const getOptions = (element) => {
  let type = "carousel";

  const defaults = {
    "data-backgroundColour": "#FFFFFF",
    "data-descriptionColour": "#000000",
    "data-headlineColour": "#000000",
    "data-ctaBorderColour": "#000000",
    "data-ctaHoverBorderColour": "#000000",
    "data-ctaFillColour": "#000000",
    "data-ctaHoverFillColour": "#FFFFFF",
    "data-ctaColour": "#000000",
    "data-ctaHoverColour": "#000000",
    "data-buttonColour": "#ff5400",
    "data-sortingOption": "photorank",
  };

  const getValOrDefault = (key) => {
    key = key.toLowerCase();
    if (
      element.attributes[key] &&
      element.attributes[key].value !== undefined
    ) {
      return element.getAttribute(key);
    } else {
      return defaults[key];
    }
  };

  return {
    type: type,
    authToken: getValOrDefault("data-authToken"),
    sortingOption: getValOrDefault("data-sortingOption"),
    backgroundColour: getValOrDefault("data-backgroundColour"),
    categoryId: element.getAttribute("data-categoryid"),
    headline: element.getAttribute("data-headline"),
    headlineColour: getValOrDefault("data-headlineColour"),
    description: getValOrDefault("data-description"),
    descriptionColour: getValOrDefault("data-descriptionColour"),
    testApiUrl: element.getAttribute("data-testapiurl"),
    buttonColour: getValOrDefault("data-buttonColour"),
    ctaBorderColour: getValOrDefault("data-ctaBorderColour"),
    ctaHoverBorderColour: getValOrDefault("data-ctaHoverBorderColour"),
    ctaFillColour: getValOrDefault("data-ctaFillColour"),
    ctaHoverFillColour: getValOrDefault("data-ctaHoverFillColour"),
    ctaColour: getValOrDefault("data-ctaColour"),
    ctaHoverColour: getValOrDefault("data-ctaHoverColour"),
    ctaText: getValOrDefault("data-ctaText"),
    ctaRef: getValOrDefault("data-ctaRef"),
    editorial: element.hasAttribute("data-editorial"),
  };
};
